//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { attendanceOvertimeDetail } from 'api/Attendance';
export default {
  props: {},
  data: function data() {
    return {
      title: '',
      // 标题
      gridData: [],
      // 表格数据
      type: '' // 加班类型文案
    };
  },

  methods: {
    handleClose: function handleClose() {
      this.$emit('update:visible', false);
    },
    // 加班详情
    handlerGetData: function handlerGetData(msg) {
      var _this = this;
      this.title = this.$t('1641', {
        x: msg.staff_name
      });
      attendanceOvertimeDetail(msg).then(function (_ref) {
        var data = _ref.data;
        _this.gridData = data.list;
        _this.type = data.type;
      });
    }
  }
};